var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"preview",staticClass:"preview"},[(_vm.file.image)?_c('img',{attrs:{"src":_vm.file.image,"alt":_vm.file.original}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }